const defaultRoutes = [
  {
    name: 'AccessDenied',
    path: '/access-denied',
    component: () => import('@/components/Views/General/AccessDenied.vue'),
    meta: { layout: 'the-default-layout' },
  },
  {
    name: 'PageNotFound',
    path: '/:catchAll(.*)',
    component: () => import('@/components/Views/General/PageNotFound.vue'),
    meta: { layout: 'the-default-layout' },
  },
];

export default defaultRoutes;
